import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '@shared';

import { RouteKeyNumberComponent } from './route-key-number.component';

@NgModule({
    imports: [CommonModule, SharedModule],
    exports: [RouteKeyNumberComponent],
    declarations: [RouteKeyNumberComponent]
})
export class RouteKeyNumberModule {}
